import { ButtonTicketLine } from 'Components/lines/button-ticket-line/ButtonTicketLine';
export default ButtonTicketLine;
